import React, { useState } from "react";
import "../styles/Gallery.css";

const photos = [
  "/images/galeria1.jpg",
  "/images/galeria2.jpg",
  "/images/galeria3.jpg",
  "/images/galeria4.png",
  "/images/galeria5.jpg",
  "/images/galeria6.jpg",
  "/images/galeria7.jpg",
  "/images/galeria8.jpg",
  "/images/galeria9.jpg",
  "/images/galeria10.jpg",
  "/images/galeria11.jpg",
  "/images/galeria12.jpg",
  "/images/galeria13.jpg",
  "/images/galeria14.jpg",
 
  "/images/galeria16.jpg",
  "/images/galeria17.jpg",
  "/images/galeria18.jpg",
  "/images/galeria19.jpg",
  "/images/galeria20.jpg"
  
];

const videos = [
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo1.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo2.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo3.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo4.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo5.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo6.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo7.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo8.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo9.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo10.mp4",
  "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/galeriaVideo11.mp4",
];

const Gallery = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("photos");
  const [lightboxVideoOpen, setLightboxVideoOpen] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
  };

  const renderGalleryItems = () => {
    if (activeTab === "photos") {
      return photos.map((src, index) => (
        <div
          key={index}
          className="gallery-item"
          onClick={() => openLightbox(index)}
        >
          <img src={src} alt={`Galería ${index + 1}`} />
        </div>
      ));
    } else {
      return videos.map((src, index) => (
        <div key={index} className="gallery-item">
          <video
            controls
            width="100%"
            className="gallery-video"
            onClick={() => {
              setCurrentVideoIndex(index);
              setLightboxVideoOpen(true);
            }}
          >
            <source src={src} type="video/mp4" />
            Tu navegador no soporta este video.
          </video>
        </div>
      ));
    }
  };

  return (
    <section className="gallery-section">
      <h2 className="gallery-title">Galería</h2>
      <p className="gallery-description">
        Doina Barbu es una reconocida médium y sanadora con años de experiencia en el ámbito espiritual. Especializada en lecturas del tarot, DoinaRo28 ofrece una visión profunda y esclarecedora sobre el pasado, presente y futuro de sus consultantes. Además, es experta en la limpieza de energías, utilizando técnicas ancestrales para restaurar el equilibrio y la armonía en la vida de las personas. Complementando sus habilidades espirituales, DoinaRo28 también proporciona remedios naturales, combinando su conocimiento de la medicina tradicional con prácticas holísticas para promover la salud y el bienestar integral. A través de las imágenes en esta galería, puedes apreciar la conexión y dedicación con la que Doina realiza cada una de sus prácticas, reflejando su compromiso y pasión por ayudar a los demás.
      </p>

      <div className="gallery-tabs">
        <button
          className={activeTab === "photos" ? "active" : ""}
          onClick={() => setActiveTab("photos")}
        >
          Fotos
        </button>
        <button
          className={activeTab === "videos" ? "active" : ""}
          onClick={() => setActiveTab("videos")}
        >
          Videos
        </button>
      </div>

      {activeTab === "photos" && (
        <div className="gallery-grid gallery-grid-photos">
          {photos.map((src, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => openLightbox(index)}
            >
              <img src={src} alt={`Galería ${index + 1}`} />
            </div>
          ))}
        </div>
      )}

      {activeTab === "videos" && (
        <div className="gallery-grid gallery-grid-videos">
          {videos.map((src, index) => (
            <div key={index} className="gallery-item">
              <video
                width="100%"
                className="gallery-video"
                onClick={() => {
                  setCurrentVideoIndex(index);
                  setLightboxVideoOpen(true);
                }}
              >
                <source src={src} type="video/mp4" />
                Tu navegador no soporta este video.
              </video>
            </div>
          ))}
        </div>
      )}

      {lightboxOpen && activeTab === "photos" && (
        <div className="lightbox">
          <span className="lightbox-close" onClick={closeLightbox}>
            &times;
          </span>
          <button className="lightbox-prev" onClick={prevImage}>
            &#10094;
          </button>
          <img src={photos[currentIndex]} alt={`Galería ${currentIndex + 1}`} className="lightbox-img" />
          <button className="lightbox-next" onClick={nextImage}>
            &#10095;
          </button>
        </div>
      )}

      {lightboxVideoOpen && activeTab === "videos" && (
        <div className="lightbox">
          <span className="lightbox-close" onClick={() => setLightboxVideoOpen(false)}>
            &times;
          </span>
          <video controls autoPlay className="lightbox-video">
            <source src={videos[currentVideoIndex]} type="video/mp4" />
            Tu navegador no soporta este video.
          </video>
        </div>
      )}
    </section>
  );
}

export default Gallery;